import { actions } from './partner_doctor/actions'
import { getters } from './partner_doctor/getters'
import { state } from './partner_doctor/state'
import { mutations } from './partner_doctor/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}